import {useEffect, useRef, useState} from "react";
import {
    CUSTOM_TEXT,
    MINUTE_TEXT,
    SECONDS, UNLIMITED_TEXT,
    YUJA_DROPDOWN_SIZE
} from "../utils/constants";
import {notifyError} from "../utils/helpers";
import classes from "./Dropdown.module.css";
import {YuJaTooltip} from "./standardization/YuJaTooltip";
import {YuJaDropdown} from "./standardization/YuJaDropdown";
import {ReactComponent as CHECK_ICON} from "../images/check_marker_purple.svg"
import {ReactComponent as TIME_LIMIT_ICON} from "../images/time_limit_purple.svg"


export default function DropdownTimeLimit({setTimeLimit, timeLimit}) {
    const [isSelectedCustom, setIsSelectedCustom] = useState(false);
    const inputRef = useRef();
    const [inputVal, setInputVal] = useState("");

    const options = [
        {label: UNLIMITED_TEXT, value: "0"},
        {label: "15 " + SECONDS, value: "15"},
        {label: "30 " + SECONDS, value: "30"},
        {label: "1 " + MINUTE_TEXT, value: "60"},
        {label: CUSTOM_TEXT, value: "-1"},
    ];

    const getSecondsFromFormatedTime = (formatedTime) => {
        if (!formatedTime) {
            return 0;
        }

        let regResult = formatedTime.match(/^([0-5]?[0-9])(:([0-5]?[0-9])?)?$/);
        if (regResult === null) {
            notifyError("Invalid time");
            return null;
        }

        const minutes = !!regResult[1] ? parseInt(regResult[1]) : 0;
        const seconds = !!regResult[3] ? parseInt(regResult[3]) : 0;

        return minutes * 60 + seconds;
    }



    const getFormatedTimeFromSeconds = (timeLimit) => {

        let minutes = Math.floor(timeLimit / 60);
        let seconds = timeLimit % 60;

        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }


    const translateDropdownValue = (timeLimit) => {
        if (!timeLimit || isNaN(timeLimit)) {
            return "0";
        }

        if (timeLimit === 15 || timeLimit === 30 || timeLimit === 60) {
            return timeLimit.toString();
        }

        return "-1";
    }

    const onChange = (option) => {
        if (option.value === "-1") {
            setIsSelectedCustom(true);
            setInputVal(translateDropdownValue(timeLimit) !== "-1" ? "" : getFormatedTimeFromSeconds(timeLimit));
        } else {
            setTimeLimit(parseInt(option.value));
        }
    }

    useEffect(() => {
        if (isSelectedCustom) {
            inputRef.current.focus();
        }
    }, [isSelectedCustom]);

    const onChangeCustomInput = (e) => {
        let input = e.target.value;

        let result = '';
        for (let i = 0; i < input.length; i++) {
            if (result.length === 2) {
                result += ':';
            }

            const char = input[i];
            if (/\d/.test(char)) {
                result += char;
            }

            if (result.length === 5) {
                break;
            }
        }

        if (result.length === 2 && inputVal.length === 1) {
            result += ':';
        }

        if (result.length >= 2) {
            result = `${Math.min(parseInt(result.slice(0, 2)), 59).toString().padStart(2, '0')}${result.slice(2, 5)}`;
        }

        if (result.length === 5) {
            result = `${result.slice(0, 2)}:${Math.min(parseInt(result.slice(3, 5)), 59).toString().padStart(2, '0')}`;
        }


        setInputVal(result);

    }

    const onBlur = (e) => {
        if (e.target.value !== undefined && e.target.value !== "") {
            let seconds = getSecondsFromFormatedTime(e.target.value);
            if (!isNaN(seconds) && !isNaN(parseInt(seconds))) {
                setTimeLimit(seconds);
            }
        } else {
            setTimeLimit(0);
        }
        setIsSelectedCustom(false);
    }

    const customPresenter = () => {
        let val = translateDropdownValue(timeLimit);
        if (val !== "0") {
            return getFormatedTimeFromSeconds(timeLimit);
        } else {
            return options.find(opt => opt.value === val).label;
        }
    }

    return (
        <div style={{position: 'relative', width: 170, height: 35}}>
            <div
                className={classes.inputContainer}
                style={{visibility: isSelectedCustom ? "visible" : "hidden",}}
            >
                <span className={classes.icon}><TIME_LIMIT_ICON/></span>
                <YuJaTooltip placement={"bottom"} text={"Enter time"}>
                    <input
                        ref={inputRef}
                        value={inputVal}
                        onChange={onChangeCustomInput}
                        onBlur={onBlur}
                        placeholder={"MM:SS"}
                    />
                </YuJaTooltip>
                {isSelectedCustom &&
                    <CHECK_ICON style={{cursor: "pointer"}} title={"confirm"}/>
                }
            </div>


            <YuJaDropdown
                ariaLabel={"Timer"}
                size={YUJA_DROPDOWN_SIZE.SMALL}
                style={{width: 170, padding: "0 6px"}}
                data={options}
                value={translateDropdownValue(timeLimit)}
                onChange={onChange}
                customPresenter={customPresenter}
                presenterIcon={<span className={classes.icon}><TIME_LIMIT_ICON/></span>}
            />
        </div>
    );
}